import React from "react";
import { InputLabelStyled } from "./styled";

const LabelText = ({ label, isRequired = false }) => {
  return (
    <InputLabelStyled>
      {label}
      {isRequired && <span>*</span>}
    </InputLabelStyled>
  );
};

export default LabelText;
